import { ClassType, EntityType } from '@frontend/common';
import { DefaultBadge } from '@frontend/components/badge';
import { StatusBadge, accountIdFromResolvedEntity } from '@frontend/components/common';
import { defaultCellClassName } from '@frontend/components/list';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { IoTExtendedClient } from '@frontend/iot/api';
import { IoTExtended } from '@frontend/iot/types';
import { CommonMessage } from '@frontend/lang';

import { usePlatformModalHost } from '../../../modal/platform-modal-host/platform-modal-host.context';
import { PlatformObjectBadge } from '../../../modal/platform-object-badge/platform-object-badge.component';
import OverviewHeader from '../../header/overview-header';
import { useInfrastructure } from './infrastructure.controller';

export const Infrastructure = () => {
    const viewProps = useInfrastructure();
    const { openPlatformDetail } = usePlatformModalHost();

    return (
        <div
            key='infrastructure'
            className='size-lf-stretch bg-background-default inline-flex w-full flex-col items-start justify-start gap-6'>
            <OverviewHeader
                title={
                    <div className='flex gap-1'>
                        <span>{CommonMessage.LICENSES.MONITORING.DEFAULT}</span>
                        <span>/</span>
                        <span>{CommonMessage.LICENSES.MONITORING.INFRASTRUCTURE}</span>
                    </div>
                }
            />
            <ReactiveObjectList<IoTExtended>
                dispatch={viewProps.dispatch}
                onSelectElement={(obj) => openPlatformDetail({ entityType: EntityType.IOT, id: obj.id })}
                fetch={(arg) => IoTExtendedClient.fetchIoTsExtended(arg)}
                activeFilter={{
                    searchKeys: ['name', 'status'],
                    filterKeys: ['spot_id', 'iot_type'],
                    displayName: new Map([
                        ['name', CommonMessage.OBJECTS.IOT.ASSET.DEFAULT],
                        ['spot_id', CommonMessage.OBJECTS.SPOT.DISTRI_SPOT],
                        ['status', CommonMessage.OBJECTS.COMMON_FIELDS.STATUS],
                        ['iot_type', CommonMessage.OBJECTS.COMMON_FIELDS.TYPE]
                    ]),
                    queryKeyMap: new Map([['iot_type', 'type']])
                }}
                columns={{
                    columns: ['name', 'type', 'status', 'spot', 'version', 'heartbeat_timestamp'],
                    headerOverwrite: new Map([
                        ['name', CommonMessage.OBJECTS.IOT.ASSET.DEFAULT],
                        ['spot', CommonMessage.OBJECTS.SPOT.DISTRI_SPOT],
                        ['version', CommonMessage.OBJECTS.COMMON_FIELDS.VERSION],
                        ['heartbeat_timestamp', CommonMessage.OBJECTS.COMMON_FIELDS.HEARTBEAT_TIMESTAMP]
                    ]),
                    customCells: new Map([
                        [
                            'spot',
                            (obj) => (
                                <td className={defaultCellClassName}>
                                    {obj.row.original.spot ? (
                                        <PlatformObjectBadge
                                            id={obj.row.original.spot.entity_id}
                                            entityType={obj.row.original.spot.entity_type}
                                            display={obj.row.original.spot.name}
                                            foreign={obj.row.original.spot.foreign}
                                            accountId={accountIdFromResolvedEntity(obj.row.original.spot)}
                                        />
                                    ) : (
                                        <span>/</span>
                                    )}
                                </td>
                            )
                        ],
                        [
                            'type',
                            (obj) => (
                                <td className={defaultCellClassName}>
                                    <DefaultBadge
                                        styles={{ container: { color: 'bg-brand-muted' } }}
                                        label={obj.row.original.type.replace(/_/g, ' ')}
                                    />
                                </td>
                            )
                        ],
                        [
                            'status',
                            (obj) => (
                                <td className={defaultCellClassName}>
                                    <StatusBadge
                                        value={obj.row.original.status}
                                        colorMap={
                                            new Map([
                                                [['offline'], ClassType.DANGER],
                                                [['online'], ClassType.SUCCESS]
                                            ])
                                        }
                                    />
                                </td>
                            )
                        ]
                    ])
                }}
                type={EntityType.IOT}
            />
        </div>
    );
};
